import TournamentHeader from "./TournamentHeader";
import { useEffect, useState,useContext,useLayoutEffect } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import { Link,useLocation,useNavigate,useParams } from "react-router-dom";
import { getDateLocaleString, convertUctToLocalTime, convertLocalTimeToUtcDbString, getCurrentLocalTime,getCurrentLocalTimeFomatted } from "../../utils/timezone";

import axios from "axios";
import UserContext from "../../components/appContext";
import {enqueueSnackbar } from "notistack";
import { hasPrivilege } from "../../components/privileges";


const SitAndSpinAwards = () =>{
    const [pageTitle, setPageTitle] = useState("Awards");
    const [awardData, setAwardData] = useState([]);
    const [gameData, setGameData] = useState();
    const [awardTypes, setAwardTypes] = useState([]);
    const [inboxApplicable , setInboxApplicable] = useState(false);
    const {userToken,databaseURL, privileges} = useContext(UserContext);
    const [disableForm, setDisableForm] = useState(false);
    const [disableLiveTournament, setDisableLiveTournament] = useState(false);
    const { id } = useParams();

    const isSkyVegas = window.location.href.includes("skyvegas");

    useEffect(() =>{
        if(hasPrivilege(privileges,"ADMIN_GAMES") === true){
            getAwardTypeData();
            if(id){
                getAwardData();
            }
        }
    },[])

    if(hasPrivilege(privileges,"ADMIN_GAMES") !== true){
        
        return(<div className="mt-4"><Row className="mb-4">
            <Col xs={6} >
                <h5>You don't have access to this page</h5>
            </Col>
            <Col xs={6} >
            
                <div className="text-end"><Link to="/tournaments"><Button size="sm">Back</Button></Link></div>
            
            </Col>
        </Row></div>)
    }

    const getGameData = async(startDate,endDate,tournamentisActive) =>{ 
        return await axios
            .get(`${databaseURL}/games/game-form-data`,{
                headers:{
                    'Authorization':`Bearer ${userToken}`
                }
            })
            .then((response) =>{
                if(response.status === 200){
                    if(response.data.data[0].siteConfigs && response.data.data[0].siteConfigs.data){
                        response.data.data[0].siteConfigs.data.forEach(config =>{
                          if(config.configKey === "disableLiveTournament"){
                                setDisableLiveTournament(config.configValue === "1" ? true : false);
                                if(endDate !== "" && startDate !== ""){
                                    let startTime = getDateLocaleString(startDate,'YYYY-MM-DD HH:mm'); 
                                    let endTime = getDateLocaleString(endDate,'YYYY-MM-DD HH:mm'); 

                                    if(( getCurrentLocalTimeFomatted()> startTime ) && (getCurrentLocalTimeFomatted()< endTime ) && tournamentisActive){
                                        setDisableForm(true);
                                    }
                                }
                            }
                        })
                    } 
                    
                    
                  } 
            })
            .catch((error)=>{
                console.log("Error getting gameData");
                enqueueSnackbar("Error getting gameData", {variant: 'error'});
                return false;
            })
    }

    const getAwardData = async() =>{ 
        return await axios
            .get(`${databaseURL}/games/${id}/awards`,{
                headers:{
                    'Authorization':`Bearer ${userToken}`
                }
            })
            .then((response) =>{

                if(response.data){
                    setPageTitle(`Awards For ${response.data.game.name}`);
                    setGameData(response.data.game);
                    if(response.data.gameAwards){
                        setAwardData(response.data.gameAwards)
                        setInboxApplicable(response.data.gameAwards.filter(award => award.inboxid && award.inboxid !== "").length > 0);
    
                    }
                    if(response.data.game.isDuplicate === 1){
                        setDisableForm(true);
                    }
                    getGameData(response.data.game.startDate, response.data.game.endDate,response.data.game.isActive);
               
                }
            })
            .catch((error)=>{
                console.log("Error getting Award Data");
                enqueueSnackbar("Error getting Award Data", {variant: 'error'});
                return false;
            })
    }

    const getAwardTypeData = async() =>{ 
        return await axios
            .get(`${databaseURL}/games/awards-form-data`,{
                headers:{
                    'Authorization':`Bearer ${userToken}`
                }
            })
            .then((response) =>{
                
                    //setCompanyKey(response.data.data[0].companyKey)
                if(response.status === 200){
                    setAwardTypes(response.data.data)
                    
                }
            })
            .catch((error)=>{
                console.log("Error getting Award Types");
                enqueueSnackbar("Error getting Award Types", {variant: 'error'});
                return false;
            })
    }

    const saveData = async() =>{
        if(awardData.length < 1){
            enqueueSnackbar("Please ensure there is at least 1 award set", {variant: 'error'});
            return;
        }

        await axios
        .post(`${databaseURL}/games/${id}/sitandspinawards`, generateBody(),{headers:{
            'Authorization':`Bearer ${userToken}`
        }})
        .then((response) => {
            enqueueSnackbar("Game Awards saved successfully", {variant: 'success'});

            setPageTitle(`Awards For ${response.data.game.name}`);
            if(response.data.gameAwards){
                setAwardData(response.data.gameAwards)
            }
        })
        .catch( async (error) => {

            enqueueSnackbar("Game Awards save failed", {variant: 'error'});
            console.log(error);


        }
        ) 
    }

    const generateBody = () =>{
        console.log("gameAwards");
        console.log(awardData);
        const body = ({
            gameAwards: awardData.filter(award => award.minrange !=  null && award.maxrange != null)
    
        }
        );
        return body;
    }
    const addAward = () =>{
        if(awardData.length <10){
            const newEmptyAward = {};

            if(awardTypes && awardTypes.length > 0){
            newEmptyAward.type = awardTypes[0].text;
            
            }   
            newEmptyAward.minrange = awardData.length+1;
            newEmptyAward.maxrange = awardData.length+1;

            setAwardData(prev => [...prev, newEmptyAward]);
        }else{
            enqueueSnackbar("You can only set 10 awards", {variant: 'error'});
        }
    }

    const removeAward = (gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr.splice(index, 1);
            setAwardData([...arr])
        }
    }

    const updateMinRange = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].minrange = e.target.value;
            setAwardData([...arr])
        }
    }
    
    const updateMaxRange = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].maxrange = e.target.value;
            setAwardData([...arr])
        }
    }

    const updatePrizeBoard = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].prizeboard = e.target.value;
            setAwardData([...arr])
        }
    }
    const updateAwardText = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].awardtext = e.target.value;
            setAwardData([...arr])
        }
    }

    const updateAwardValue = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].value = e.target.value;
            setAwardData([...arr])
        }
    }

    const updateNumWinners = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].numwinners = e.target.value;
            setAwardData([...arr])
        }
    }
    const updateAwardType = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].type = e.target.value;
            setAwardData([...arr])
        }
    }

    const updateAwardCode = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].code = e.target.value;
            setAwardData([...arr])
        }
    }

    const updateAwardInboxId = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].inboxid = e.target.value;
            setAwardData([...arr])
        }
    }
    const updateAwardInboxIdbyVal = (val,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].inboxid = val;
            setAwardData([...arr])
        }
    }
    const updateCostOfPrizes = (e,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].costofprizes = e.target.value;
            setAwardData([...arr])
        }
    }

    const updateFreq = (val,gameAward) =>{
        const arr = [...awardData];
        const index = arr.indexOf(gameAward);
        if (index !== -1) {
            arr[index].frequency = val.target.value;
            setAwardData([...arr])
        }
    }


    const handleInboxApplicable = (val) =>{
        setInboxApplicable(val);
        if(val === false){
            for(let award in awardData){
                updateAwardInboxIdbyVal("",awardData[award])
            }
        }
    }
    

    const inputKeydown =(evt)=>{
        switch(evt.key){
            case "e":
            case "E":
            case "-":
            case "+":
            case "/":
            case "*":
            case ".":
                evt.preventDefault();
                return false;
        }
    }

    return(
        <div className="mt-4">
            <Row className="mb-1">
                <Col xs={12} >
                    <TournamentHeader id={id} isRealMoney={gameData && gameData.realPlay === 1 ? true : false} isSitAndSpin={gameData && gameData.mode === 3 ? true : false}></TournamentHeader>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col xs={12} >
                    <h5>{pageTitle}</h5>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col xs={12} >
                <Form.Check onChange={e => {handleInboxApplicable(e.target.checked)}} checked={inboxApplicable} type="checkbox" id="inboxApplicable" label={"Inbox applicable"} disabled={disableForm}/> 
                   
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12} >
                    <b>No of Prizes:</b> the amount of prizes available to win<br/>
                    <b>Freq%:</b> Chance of being selected as the award. The higher the % the more likely<br/>
                    <b>Award Text:</b> Text that appears on the wheel and lobby. For lobby icons use CASH, FREE SPINS or BONUS<br/>

                    {!isSkyVegas && <><b>Amount:</b> The prize value, use pence for cash<br/></> }
                    {!isSkyVegas && <><b>Type:</b> Type of award linked to reconcile <br/></> }
                    {!isSkyVegas && <><b>Cost:</b> The cost of the prize <br/></> }

                    {isSkyVegas && <><b>Master Promo ID (Blueprint):</b> Used for reconcile to match with external back office <br/></> }
                    {!isSkyVegas && <><b>Code:</b> Used for reconcile to match with external back office <br/></> }
                    <i>* Please ensure the top prize is first in the list and the lowest is last</i><br/>
                </Col>
            </Row>
            <Row className="pt-2 pb-2 border-bottom border-top">
                <Col xs={1} className="fw-bold">#</Col>
                <Col xs={1} className="fw-bold">No Of Prizes</Col>
                <Col xs={1} className="fw-bold">Freq %</Col>
                <Col xs={2} className="fw-bold">Award Text</Col>
                {!isSkyVegas && <><Col xs={1} className="fw-bold">Amount</Col></> }
                {!isSkyVegas && <> <Col xs={1} className="fw-bold">Cost</Col></> }
                {!isSkyVegas && <><Col xs={2} className="fw-bold">Type</Col></> }
                
                {inboxApplicable === true ?
                    <>
                    <Col xs={1} className="fw-bold">Code</Col>
                    <Col xs={1} className="fw-bold">InboxId</Col>
                    </>
                : <>
                {isSkyVegas && <><Col xs={2} className="fw-bold">Master Promo ID (Blueprint)</Col></> }
                {!isSkyVegas && <><Col xs={2} className="fw-bold">Code</Col></> }
                </>
                    
                }
                <Col xs={1} className="fw-bold"></Col>
            </Row>
            {awardData && awardData.map((award, index) =>               
            <Row key={index} className="pt-2 pb-2 border-bottom">
            
                <Col xs={1} className="mt-auto mb-auto">{award.minrange}</Col>
                <Col xs={1} className="mt-auto mb-auto"><Form.Control style={{maxWidth:"200px"}} className="mb-1" maxLength="25" type="number" min={0} onKeyDown={e => inputKeydown(e)} onChange={(e) => updateNumWinners(e, award)}  size="sm" value={award.numwinners} disabled={disableForm}></Form.Control></Col>
                <Col xs={1} className="mt-auto mb-auto"><Form.Control style={{maxWidth:"200px"}} className="mb-1" maxLength="25" type="text" onChange={(e) => updateFreq(e, award)}  size="sm" value={award.frequency} disabled={disableForm}></Form.Control></Col>
                <Col xs={2} className="mt-auto mb-auto"><Form.Control className="mb-1" maxLength="25" type="text" onChange={(e) => updatePrizeBoard(e, award)}  size="sm" value={award.prizeboard} disabled={disableForm}></Form.Control></Col>

                  {!isSkyVegas && <><Col xs={1} className="mt-auto mb-auto"><Form.Control className="mb-1" maxLength="25" type="text" onChange={(e) => updateAwardValue(e, award)}  size="sm" value={award.value} disabled={disableForm}></Form.Control></Col></> }
                    {!isSkyVegas && <> <Col xs={1} className="mt-auto mb-auto"><Form.Control className="mb-1" maxLength="25" type="text" onChange={(e) => updateCostOfPrizes(e, award)}  size="sm" value={award.costofprizes} disabled={disableForm}></Form.Control></Col></> }
                
                {!isSkyVegas && <> 

                <Col xs={2} className="mt-auto mb-auto">
                
                {awardTypes && awardTypes.length>0 ?
                <Form.Select style={{width:"auto"}} onChange={(e) => updateAwardType(e, award)} aria-label="gameType-select" size="sm" disabled={disableForm}>
                    {awardTypes.map((atype, i)=>
                        <option key={i} value={atype.text} selected={award.type === atype.text ? true : false}>{atype.text}</option>
                    )}
                    
                </Form.Select>
                :
                <Form.Control className="mb-1" maxLength="25" type="text" size="sm" onChange={(e) => updateAwardType(e, award)} value={award.type} disabled={disableForm}></Form.Control>
                
                }   
                </Col>

                </> }
                {inboxApplicable === true ?
                    <>
                    <Col xs={1} className="mt-auto mb-auto"><Form.Control className="mb-1" type="text" size="sm" value={award.code} onChange={(e) => updateAwardCode(e, award)} disabled={disableForm} ></Form.Control></Col>
                    <Col xs={1} className="mt-auto mb-auto"><Form.Control className="mb-1" type="text" size="sm" value={award.inboxid} onChange={(e) => updateAwardInboxId(e, award)} disabled={disableForm} ></Form.Control></Col>
                
                    </>
                :
                
                    <Col xs={2} className="mt-auto mb-auto"><Form.Control className="mb-1" type="text" size="sm" value={award.code} onChange={(e) => updateAwardCode(e, award)} disabled={disableForm} ></Form.Control></Col>
                }
                {disableForm === false &&
                <Col xs={1} className="mt-auto mb-auto"><Button size="sm" className="mb-1 me-1" variant="secondary" onClick={() => removeAward(award)}>Remove</Button></Col>
                }

            </Row>
            )}
             <Row className="mt-3 mb-3">
             {disableForm === false &&
                <Col className="text-center"><Button variant="secondary" onClick={addAward}>Add Award</Button> <Button onClick={saveData}>Save Award</Button></Col>
             }
            </Row>
        </div>
    );
}
export default SitAndSpinAwards;